// ═══════════════════════════════════════════════════════════════════════════════
// Task submission photo via authed API → blob URL (no GCS URL in img src)
// ═══════════════════════════════════════════════════════════════════════════════

import { useAuthedApiImageBlobUrl } from '../receipt/useReceiptImageDisplay';

const EXPIRED_IMAGE_FALLBACK_SRC = '/img/img_expired-1.webp';

export type TaskInstancePhotoImgProps = {
  taskInstanceId: string;
  photoIndex: number;
  alt: string;
  className?: string;
};

export const TaskInstancePhotoImg = ({
  taskInstanceId,
  photoIndex,
  alt,
  className = '',
}: TaskInstancePhotoImgProps) => {
  const apiPath = `/api/task-instances/${encodeURIComponent(taskInstanceId)}/photos/${photoIndex}`;
  const { objectUrl, loading, error } = useAuthedApiImageBlobUrl(apiPath);

  if (loading) {
    return (
      <div
        className={`flex items-center justify-center bg-gray-100 dark:bg-gray-800 ${className}`}
        role="status"
        aria-live="polite"
      >
        <div className="h-6 w-6 animate-spin rounded-full border-2 border-primary-200 border-t-primary-600" />
      </div>
    );
  }

  if (error || !objectUrl) {
    return <img src={EXPIRED_IMAGE_FALLBACK_SRC} alt={alt} className={className} />;
  }

  return <img src={objectUrl} alt={alt} className={className} />;
};
